import { PlayerAhoyLivestreamEvent } from "../player_ahoy_livestream_event";
import { PlayerEnvironment } from "../player_environment";
import DrmDetector from '../utils/drm_detector';

export default class LivestreamPlenty {
  constructor( options = {} ){
    this._tech = options.tech;
    this._data = options.data;
    this._drmDetector = new DrmDetector();
  }

  data(){
    return this._data;
  }

  tech(){
    return this._tech;
  }

  drmDetector() {
    return this._drmDetector;
  }

  bindEvents(){
    this.bindStart();
    this.bindPlay();
    this.bindError();
    this.bindMeta();
    this.bindBuffer();
    this.bindSeek();

    this.bindAdWatch();
  }

  bindSeek(){
    this.tech().on("vp-video-seek", function(e){
      PlayerAhoyLivestreamEvent.sendGeneralSeek(e.id, 'livestreaming', e.position, e.offset, e.play_uuid, e.action);
    });
  }

  bindStart(){
    this.tech().on("vp-livestream-start", (e) => {
      this.drmDetector().widevineHdcpCheck().then(hdcp_support => {
        PlayerAhoyLivestreamEvent.sendStart(
          e.id,
          e.streamType,
          e.hasAd,
          e.uuid,
          e.currentTime,
          e.readyState,
          e.networkState,
          e.bufferedVideoFrames,
          e.bandwidth,
          e.quality,
          e.assetSource,
          e.codec,
          hdcp_support,
          e.videoSourceBitrate,
          e.videoSourceHeight,
          e.videoSourceWidth,
          e.playerHeight,
          e.playerWidth,
        );
      }).catch(() => {
        PlayerAhoyLivestreamEvent.sendStart(
          e.id,
          e.streamType,
          e.hasAd,
          e.uuid,
          e.currentTime,
          e.readyState,
          e.networkState,
          e.bufferedVideoFrames,
          e.bandwidth,
          e.quality,
          e.assetSource,
          e.codec,
          'unknown',
          e.videoSourceBitrate,
          e.videoSourceHeight,
          e.videoSourceWidth,
          e.playerHeight,
          e.playerWidth,
        );
      });
    });
  }

  bindPlay(){
    this.tech().on("vp-livestream-play", function(e){
      PlayerAhoyLivestreamEvent.sendPlay(
        e.id,
        e.seconds,
        e.uuid,
        e.toggle,
        e.bandwidth,
        e.quality,
        e.assetSource,
        e.networkState,
        e.hasAd,
        e.streamType,
        e.videoSourceBitrate,
        e.videoSourceHeight,
        e.videoSourceWidth,
        e.playerHeight,
        e.playerWidth,
      );
    });
  }

  bindError(){
    this.tech().on("vp-livestream-error", function(e){
      PlayerAhoyLivestreamEvent.sendError(
        e.id,
        e.errorCode,
        e.errorMessage,
        e.videoDuration,
        e.currentTime,
        e.uuid,
        e.readyState,
        e.networkState,
        e.bufferedVideoFrames,
        e.assetSource
      );
    });
  }

  bindMeta(){
    this.tech().on("vp-livestream-meta", function(e){
      PlayerAhoyLivestreamEvent.sendMeta(e.id, e.level, e.levels, e.targetBitrate, e.uuid);
    });
  }

  bindBuffer(){
    this.tech().on("vp-livestream-buffer", function(e){
      PlayerAhoyLivestreamEvent.sendBuffer(
        e.id,
        e.seconds,
        e.uuid,
        e.timer,
        e.streamType,
        e.bandwidth,
        e.quality,
        e.assetSource,
        e.videoSourceBitrate,
        e.videoSourceHeight,
        e.videoSourceWidth,
        e.playerHeight,
        e.playerWidth,
      );
    });
  }

  bindAdWatch(){
    this.tech().on("vp-livestream-adwatch", function(e){
      PlayerAhoyLivestreamEvent.sendAdWatch(e.id, e.duration, e.currentTime, e.uuid, e.adUUID);
    });
  }

  setAhoyEventGlobalProperties() {
    let globalData = {
      page: PlayerEnvironment.locationHref(),
      videopremier: this.data().isPremier(),
      referrer: PlayerEnvironment.referrer(),
      is_preview: this.data().preview(),
      cdn: this.data().cdnName(),
      embed: this.data().embed() === 'true',
    };

    if (this.data().userIsPremier()) {
      globalData.user_type = 'premier';
    }

    globalData.is_drm = this.data().drmEnabled();
    PlayerAhoyLivestreamEvent._globalAppendData = globalData;
  }
}
